import globalAxios from "axios";
import { getCurrentConfig } from '../api-adapter/config';
import { getAuthToken } from '../api-adapter/config';
import { getDeviceId } from '../utils/deviceId';
import { AXIOS_CONFIG } from "./sharedConfig";

// Re-export AXIOS_CONFIG for use in other files
export { AXIOS_CONFIG } from "./sharedConfig";

globalAxios.interceptors.request.use(async (config) => {

  if (!config?.headers) {
    throw new Error(
      `Expected 'config' and 'config.headers' not to be undefined`
    );
  }

  if (typeof window !== 'undefined') {
    try {
      // Get storeId from configuration instead of cookies
      const ecommerceConfig = getCurrentConfig();
      const token = getAuthToken();
      const deviceId = getDeviceId();

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      if (ecommerceConfig?.storeId) {
        config.headers["X-Store-Key"] = ecommerceConfig.storeId;
      }

      if (deviceId) {
        config.headers["x-device-id"] = deviceId;
      }
    } catch (error) {
      // Configuration not initialized yet, skip adding headers
      // Console debug only to reduce noise
      // console.debug('API configuration not initialized yet:', error);
    }
  }

  return config;
});

// Lazy-init AbortController only on client to avoid SSR errors
if (typeof window !== 'undefined') {
  const abortController = new AbortController();
  if (AXIOS_CONFIG.baseOptions) {
    AXIOS_CONFIG.baseOptions.signal = abortController.signal;
  }
}

